// @ts-nocheck
/* eslint-disable */
export const appChevronDown16Icon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 5.5L8 11L14 5.5" stroke="currentColor" stroke-width="2"/></svg>`,
    name: 'chevron-down-16' as const
};